import React from "react";
import IndividualDeliverable from "./individualDeliverable";
import { Action } from "../../../constants/Common";

const EditDeliverableModule = (props) => {
  return (
    <>
      <div
        className="editDeliverable_height"
        style={{ height: "auto", maxHeight: "900px" }}
      >
        {props?.deliverable &&
          props.deliverable?.map((dL, index) => {
            return (
              <IndividualDeliverable
                key={index}
                eachDeliverable={dL}
                action={Action.UPDATE}
                eachDeliverableIndex={index}
              />
            );
          })}
      </div>
    </>
  );
};

export default EditDeliverableModule;
